module.exports = __webpack_public_path__ + "static/media/tiny_img_1.99925ce2.png";